import React from 'react'
import { localized } from 'decorators'
import Page from './page'

const ListPage = ({ metadata, localize, persistor, children, aboveContent: AboveContent }) => {
  return (
    <Page
      title={localize(`${metadata.page}.title`)}
      metadata={metadata}
      hideGoBack
      canCreate={metadata.hideCreate !== true}
      canGoToTrash={metadata.isSoftDelete === true}
      persistor={persistor}
      localize={localize}
      >
        {AboveContent && <AboveContent />}
        {children}
    </Page>
  )
}

export default localized(ListPage)